import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ClientPick from './ClientPick';
import styled from 'styled-components';
import ClientAddForm from './ClientAddForm';
import AddressAddForm from './AddressAddForm';
import { useEffect, useState } from 'react';
import { ClientAddBody } from '../../../services/clients/add/types';
import { AddressAddBody } from '../../../services/address/add/types';
import { AddUserRequestBody } from '../../../services/users/add/types';
import { StyledButton } from '../../../components/Button/button';
import BasicUserDataFrom from './BasicUserDataForm';
import { useMutation, useQuery } from '@tanstack/react-query';
import { addUser } from '../../../services/users/add';
import { ClientAdd } from '../../../services/clients/add';
import { toast, ToastOptions } from 'react-toastify';
import { addressAdd } from '../../../services/address/add';
import { ClientUpdate } from '../../../services/clients/edit';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../../helpers/theme';
import { getAllOperatorClients } from '../../../services/clients';

const steps = ['Dane klienta', 'Adres', 'Dane konta'];

// interface ClientAddStepperProps {
//   // clientId: string | null;
//   // setClientId: (clientId: string | null) => void;
//   // setFormValid: (formValid: boolean) => void;
//   // setBasicUserDataVisible: (basicUserDataVisible: boolean) => void;
// }

const ClientAddStepper = () => {
  const navigate = useNavigate();
  const [clientAddDisabled, setClientAddDisabled] = useState<boolean>(false);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState<{
    [k: number]: boolean;
  }>({});

  const [clientId, setClientId] = useState<string | null>(null);
  const [clientData, setClientData] = useState<ClientAddBody | null>(null);
  const [clientPickedData, setClientPickedData] = useState<ClientAddBody | null>(null);
  const [clientAdditionalInfo, setClientAdditionalInfo] = useState<string | null>(null);
  const [clientDataValid, setClientDataValid] = useState<boolean>(false);
  const [addressId, setAddressId] = useState<string | null>(null);
  const [addressData, setAddressData] = useState<AddressAddBody | null>(null);
  const [addressDataValid, setAddressDataValid] = useState<boolean>(false);
  const [basicUserData, setBasicUserData] = useState<AddUserRequestBody | null>(null);
  const [basicUserDataValid, setBasicUserDataValid] = useState<boolean>(false);
  const [allDataReady, setAllDataReady] = useState<boolean>(false);

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  // if (toast) {
  //   toast.dismiss("400-error");
  // }

  const GetClientById = useQuery(
    ["OperatorClientByID"],
    () => getAllOperatorClients(
      {
        paginacja: null,
        filtr: {
          id_klient: clientId
        }
      }
    ),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
  
      onSuccess(data) {
        return data;
      },
    }
  );

  const handleClientPicked = async () => {
    if (clientId !== null) {
      const ClientPicekd = await GetClientById.refetch();
      if (ClientPicekd.data) {
      setClientPickedData(ClientPicekd.data.data.payload.klienci[0]);
      }
    }
  }
  
  useEffect(() => {
    // console.log(clientId)
    if ( clientId === null){
      setClientPickedData(null);
    } else {
      handleClientPicked()
    }
  }, [clientId]);

  //jako pierwsze dodawanie klienta
  const AddClientMutation = useMutation(ClientAdd, {
    onSuccess: (res) => {
      // toast.success("Dodano pomyślnie!", { toastId: "EditSuccessfully", ...settings });
      setClientId(res.data.payload.id_klient);
    },
    onError: (err:any) => {
      // if (err.response.data.errors_debug[0] === "someone with that email exist") {
      //   toast.error("Email zajęty", { toastId: "AddClientFailed", ...settings });
      // } else if (err.response.data.errors_debug[0] === "Adres already in use") {
      //   toast.error("Istnieje już klient o podanym adresie", { toastId: "AddClientFailed", ...settings });
      // }
    }
  });

  //jako drugie dodawanie adresu
  const addAdressMutation = useMutation(addressAdd, {
    onSuccess: (res) => {
      // toast.success("Dodano pomyślnie!", {
      //   toastId: "AddedSuccessfully",
      //   ...settings,
      // });
      // setAddressId(res.data.payload.id_klient);
    },
  });

  //jako trzecie edycja klienta
  const EditClientMutation = useMutation(ClientUpdate, {
    onSuccess: (res) => {
    },
  });
  
  //jako ostatnie dodawanie użytkownika
  const AddUserMutation = useMutation(addUser, {
    onSuccess: (res) => {
      toast.success("Dodano pomyślnie!", { toastId: "AddSuccessfully", ...settings });
    },
    onError: (err:any) => {
      if (err.response.data.errors_debug[0] === "client already in use") {
        toast.error("Konto dla podanego klienta już istnieje", { toastId: "AddUserFailed", ...settings });
      } else if (err.response.data.errors_debug[0] === "User already exist with login." || err.response.data.errors_debug[0] === "User already exist with login or email") {
        toast.error("Podany login jest już zajęty", { toastId: "AddUserFailed", ...settings });
      }
    }
  });

  const handleAllDataSend = async () => {
    if ((clientData !== null || clientId !== null) && addressData !== null && basicUserData !== null){
      const addressResp = await addAdressMutation.mutateAsync(addressData);
      setAddressId(addressResp.data.payload.id_klient);
      if (clientId !== null && clientData === null){
        const newAddressId : string = addressResp.data.payload.id_klient;
        await EditClientMutation.mutateAsync({
          id_klient: clientId,
          adres: newAddressId,
          nazwa: null,
          nip: null,
          weryfikacja: null,
          aktywny: null,
          telefon: null,
          email: null,
          info_dodatkowe: clientAdditionalInfo !== null ? clientAdditionalInfo : null,
        });

        const newBasicUserData = {
          ...basicUserData,
          klient_id: clientId,
          haslo: btoa(basicUserData.haslo),
        }
        console.log(newBasicUserData);
        await AddUserMutation.mutateAsync(newBasicUserData);
        if (AddUserMutation.isSuccess) {
          navigate(-1);
        }

      } else 
      if (clientId === null && clientData !== null) {
        const clientNewData : any = {
          ...clientData,
          adres_id: addressResp.data.payload.id_klient
        }
        const clientResp = await AddClientMutation.mutateAsync(clientNewData);
        // setClientId(clientResp.data.payload.id_klient);
        setClientData(null);
        const newBasicUserData = {
          ...basicUserData,
          klient_id: clientResp.data.payload.id_klient,
          haslo: btoa(basicUserData.haslo),
        }
        console.log(newBasicUserData);
        await AddUserMutation.mutateAsync(newBasicUserData);
        if (AddUserMutation.isSuccess) {
          navigate(-1);
        }
      }
    }
  };


  useEffect(() => {
    if ((clientData !== null || clientId !== null) && addressData !== null && basicUserData !== null && clientDataValid && addressDataValid && basicUserDataValid) {
      setAllDataReady(true);
      // console.log("gotowe do wysłania formularza");
    } else {
      setAllDataReady(false);
      // console.log("nie gotowe do wysłania formularza");
    }
  }, [clientData, clientId, addressData, basicUserData])

  useEffect(() => {
    if (clientId !== null) {
      setClientData(null);
    }
  }, [clientId]);

  useEffect(() => {
    console.log("ClientDataValid: ", clientDataValid);
  }, [clientDataValid]);

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    const completedValues = Object.values(completed);
    const completedTrueValues = completedValues.filter(value => value === true);
    return completedTrueValues.length;
  };
  

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ?
          parseInt(Object.entries(completed).find(
            ([step, isCompleted]) => isCompleted === false
          )![0])
        : 
        isLastStep() ? activeStep : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleIncomplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = false;
    setCompleted(newCompleted);
    handleNext();
  };

  // const handleReset = () => {
  //   setActiveStep(0);
  //   setCompleted({});
  // };


  return (
    <Box sx={{ width: '100%' }}>
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton color="inherit" onClick={handleStep(index)}>
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <RequiredText>
        *Pola obowiązkowe
      </RequiredText>
      <StepperContentWrapper>
        {
          activeStep === 0 
          ? 
          <>
            <ClientPick setClientId={setClientId} clientId={clientId} setClientAddDisabled={setClientAddDisabled} setClientDataValid={setClientDataValid} /> 
            <ClientAddForm setClientData={setClientData} clientData={clientData} clientPickedData={clientPickedData} clientAdditionalInfo={clientAdditionalInfo} setClientAdditionalInfo={setClientAdditionalInfo}  clientAddDisabled={clientAddDisabled} setClientId={setClientId} clientId={clientId} setClientDataValid={setClientDataValid}/>
            <StyledButton
            style={{ width: '100%' }}
            disabled={!clientDataValid}
            onClick={ () => {
              if (clientDataValid) {
                handleComplete()
              } else {
                handleIncomplete()
              }
            }
            }
            >
              Dalej
            </StyledButton>
          </>
          : 
          null
        }
        {
          activeStep === 1
          ?
          <>
            <AddressAddForm  addressData={addressData} setAddressData={setAddressData} setAddressDataValid={setAddressDataValid}/>
            <StyledButton
            style={{ width: '100%' }}
            disabled={!addressDataValid}
            onClick={ () => {
              if (addressDataValid) {
                handleComplete()
              } else {
                handleIncomplete()
              }
            }
            }
            >
              Dalej
            </StyledButton>
          </>
          :
          null
        }
        {
          activeStep === 2
          ?
          <>
            <BasicUserDataFrom basicUserData={basicUserData} setBasicUserData={setBasicUserData} setBasicUserDataValid={setBasicUserDataValid}/>
            <StyledButton
            style={{ width: '100%' }}
            disabled={!basicUserDataValid}
            onClick={ () => {
              if (basicUserDataValid && allDataReady) {
                handleAllDataSend()
              } else if (basicUserDataValid && allDataReady === false) {
                handleComplete()
              } else {
                handleIncomplete()
              }
            }}
            >
              {allDataReady ? "Zapisz" : "Dalej"}
            </StyledButton>

          </>
          :
          null
        }
      </StepperContentWrapper>
    </Box>
  );
}
export default ClientAddStepper;

const StepperContentWrapper = styled.div`
  margin-top: 25px;
`;

const RequiredText = styled.div`
  margin-top: 25px;
  text-align: center;
  // font-size: 12px;
  font-family: ${theme.fonts.interRegular};
  `;